import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Sheet, SheetContent } from "../components/ui/sheet";
import { Separator } from "../components/ui/separator";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../components/ui/collapsible";
import { ChevronUp, ChevronDown, Menu, X, UserCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userState } from "../common/atom/userState";
import SessionUpdateBtn from "../components/SessionUpdateBtn";
import LogoutBtn from "../components/LogoutBtn";
import { approvalMenuList } from "../lib/menuList";

const NavMobile = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(true);

  const user = useRecoilValue(userState) ?? {};
  const unifierUrl = process.env.REACT_APP_UNIFIER_URL;

  return (
    <div className="app-header-box">
      <img
        alt="Logo"
        src="/images/g1313.png"
        className="h-8 w-auto"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/loa/all")}
      />
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setDrawerOpen(true)}
        className="text-[#3f3f46]"
      >
        <Menu />
      </Button>
      <Sheet open={drawerOpen} onOpenChange={(open) => setDrawerOpen(open)}>
        <SheetContent
          side="right"
          className="w-auto max-w-none p-0 [&>button]:hidden"
        >
          <div className="mobile-app-drawer">
            <div className="mobile-app-drawer-header">
              <div className="flex h-[60px] items-center justify-end pr-4 shadow-md">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setDrawerOpen(false)}
                >
                  <X />
                </Button>
              </div>
            </div>
            <div className="mobile-app-drawer-scroll">
              <div className="mobile-app-drawer-menu-box">
                <nav className="w-full max-w-[360px] bg-background">
                  <Collapsible open={menuOpen} onOpenChange={setMenuOpen}>
                    <CollapsibleTrigger className="flex w-full items-center justify-between px-4 py-2 text-left hover:bg-accent">
                      <span>결재</span>
                      {menuOpen ? <ChevronUp /> : <ChevronDown />}
                    </CollapsibleTrigger>
                    <CollapsibleContent>
                      {approvalMenuList.map((c) => (
                        <button
                          key={c.path}
                          type="button"
                          className="block w-full py-2 pl-8 pr-4 text-left hover:bg-accent"
                          onClick={() => {
                            setDrawerOpen(false);
                            navigate(c.path);
                          }}
                        >
                          {c.label}
                        </button>
                      ))}
                    </CollapsibleContent>
                  </Collapsible>
                </nav>
              </div>
            </div>
            <div className="mobile-app-drawer-footer">
              <div className="mobile-drawer-user-info">
                <UserCircle className="size-9 text-[#98a2b3]" />
                <div>
                  <p className="text-sm font-bold">
                    {user.name || user.username || "-"}
                  </p>
                  {user.name && (
                    <p className="text-xs text-muted-foreground">
                      {user.username}
                    </p>
                  )}
                </div>
              </div>
              <Separator className="my-2" />
              <a
                href={unifierUrl || "#"}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => {
                  if (!unifierUrl) e.preventDefault();
                }}
                className="mx-4 mb-2 block rounded-md border border-[#e4e4e7] px-4 py-2 text-center text-[13px] font-semibold text-[#18181b] no-underline"
              >
                유니파이어 바로가기
              </a>
              <div className="mobile-app-drawer-button-box">
                <SessionUpdateBtn fullWidth />
                <LogoutBtn fullWidth />
              </div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default React.memo(NavMobile);
